"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TermFunctionHasLang = void 0;
const bus_function_factory_1 = require("@comunica/bus-function-factory");
const utils_expression_evaluator_1 = require("@comunica/utils-expression-evaluator");
const expressions_1 = require("@comunica/utils-expression-evaluator/lib/expressions");
/**
 *
 */
class TermFunctionHasLang extends bus_function_factory_1.TermFunctionBase {
    constructor() {
        super({
            arity: 1,
            operator: utils_expression_evaluator_1.SparqlOperator.HAS_LANG,
            overloads: (0, utils_expression_evaluator_1.declare)(utils_expression_evaluator_1.SparqlOperator.HAS_LANG)
                .onTerm1(() => term => (0, utils_expression_evaluator_1.bool)(term instanceof utils_expression_evaluator_1.LangStringLiteral || term instanceof expressions_1.DirLangStringLiteral))
                .collect(),
        });
    }
}
exports.TermFunctionHasLang = TermFunctionHasLang;
//# sourceMappingURL=TermFunctionHasLang.js.map